<template>
  <transition name="fade">
    <div class="popup-modal" v-if="isVisible">
      <div class="window" :style="{ width: width }">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ConfirmModal",
  data: () => ({
    isVisible: false,
  }),
  props: {
    width: {
      type: String,
      default: "450px"
    }
  },
  methods: {
    open() {
      this.isVisible = true;
    },

    close() {
      this.isVisible = false;
    },
  },
};
</script>

<style scoped>
/* css class for the transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.popup-modal {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  z-index: 100;
  overflow-y: auto;
  border: 1px solid #1b1b1b;
  border-radius: 20px;
}

.window {
  background: #fff;
  border-radius: 48px;
  /* box-shadow: inset 0 4px 0 rgba(231, 231, 231, 0.25); */
  margin-left: auto;
  margin-right: auto;
  padding: 20px 20px;
  position: relative;
  text-align: center;
  width: 450px;
  max-height: calc(100vh - 3rem);
  box-shadow: 0px 4px 4px 0px #00000040;
}
</style>
